import React from "react";
import { styled } from "goober";
import { firefoxOnly, mobile, touchOnly } from "clutch/src/Style/style.mjs";

import { OBSERVE_CLASS } from "@/util/exit-transitions.mjs";

export const ExternalContainer = styled("div")`
  container-type: inline-size;
  container-name: app;
  display: flex;
  flex-direction: column;
  height: 100vh;

  ${mobile} {
    height: 100vh;
    height: 100dvh;
  }
`;

export const InternalContainer = styled("div")`
  --base-page-padding: var(--sp-2);

  --page-width: var(--sp-container);
  --page-padding: var(--base-page-padding);

  /* this needs to be large because of the bottom ad */
  --page-end-value: var(--sp-23);
  --page-end: var(--page-end-value);
  --page-start: var(--sp-4);

  display: flex;
  flex-direction: column;
  position: relative;
  align-items: stretch;
  flex: 1;
  overflow: hidden;

  @keyframes spin {
    from {
      transform: rotate(-1turn);
    }
  }

  .blitz-loading-spinner {
    animation: spin 1s linear forwards infinite;
  }

  &.full-width-page {
    --page-width: 100%;
    --is-full-width: 1;
  }
`;

export const ContentScroller = styled("div")`
  --scroll-color: var(--shade4-50);

  position: relative;

  flex: 1;
  display: flex;
  flex-direction: column;

  border-color: transparent;

  transition: var(--transition-long);
  transition-property: border-color, scrollbar-color;

  ${
    ""
    /*
     * Don't change this or the content body won't align with the upper navbar.
     *
     * If you need to, set the page to `full-bleed` using `fullBleed` and
     * add make sure you account for the scrollbar width in the page padding using
     * the `var(--pad-for-scrollbar-offset)` variable.
     *
     * It's ok. I hate it, too.
     */
  }
  scrollbar-gutter: stable both-edges;
  --pad-for-scrollbar-offset: var(--base-page-padding)
    calc(var(--base-page-padding) - var(--scrollbar-width));

  overflow-x: hidden;
  overflow-y: scroll;

  z-index: 4;

  ${firefoxOnly} {
    --scrollbar-width: calc(100vw - 100%);

    transition: unset;

    ${"" /* Firefox doesn't like animated scrollbars */}
    scrollbar-color: var(--scroll-color) transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: transparent;
    /* add border to act as background-color */
    border-left-style: outset;
    border-width: var(--scrollbar-width);
    /* sum viewport dimensions to guarantee border will fill scrollbar */
    /* inherit border-color to inherit transitions */
    border-color: inherit;
    border-radius: calc(var(--scrollbar-width) / 2);
  }

  &.scroll-active {
    border-color: var(--scroll-color);

    transition: var(--transition-short);
  }

  &.scrollbar-hide {
    border-color: transparent !important;

    pointer-events: none;

    ${firefoxOnly} {
      scrollbar-color: transparent;
    }
  }

  &.full-bleed {
    --title-bar-height: 0px;
    --page-padding: 0px;
    --page-start: 0px;
    --page-end: 0px;
  }

  &:not(.full-bleed) {
    @container app (width <= 400px) {
      --page-padding: var(--sp-2);
    }
  }

  ${touchOnly} {
    scrollbar-gutter: unset;
    --pad-for-scrollbar-offset: 0;

    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
      -webkit-appearance: none;
    }
  }
`;

export const ContentBody = styled("div", React.forwardRef)`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-block: var(--page-start) var(--page-end);
  margin-inline: var(--page-padding);

  &:first-child {
    flex: 1;
  }

  &.full-bleed {
    --title-bar-height: 0px;
    --page-padding: 0px;
    --page-start: 0px;
    --page-end: 0px;
  }
  &:not(.full-bleed) {
    @container app (width <= 400px) {
      --page-padding: var(--sp-2);
    }
  }
`;

export const RouteWrapper = styled("div")`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;

  &.${OBSERVE_CLASS} {
    flex-grow: 1;
    width: 100%;
  }

  &[inert] {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
  }
`;
